document.querySelectorAll('.MapOnePoint').forEach((el) => {
    if (el.dataset.cords) {
        const nameStr = el.dataset.name;
        const zoom = parseInt(el.dataset.zoom);
        const cordsArr = JSON.parse(el.dataset.cords);

        try {
            ymaps.ready(function () {
                const myMap = new ymaps.Map(el, {
                    center: cordsArr,
                    zoom: isNaN(zoom) ? 9 : zoom,
                    controls: ['zoomControl'],
                });


                myMap.geoObjects
                    .add(getMapPont(cordsArr, nameStr, true));
            });
        } catch (e) {
            console.warn(e);
        }
    }
});


function getMapPont(cords, name, small = false, options = {}, optionsLayout = {}) {
    console.log('getMapPont');
    return new ymaps.Placemark(cords, {
        id: 585,
        iconContent: name,
    }, getMapPontOptions(small, options, optionsLayout));
}

function getMapPontOptions(small = false, options = {}, optionsLayout = {}) {
    const MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
        `<div class="MapOnePoint__point ${small && 'MapOnePoint__point--small'} {{ properties.classText }}">{{ properties.clusterCaption|default:properties.iconContent }}</div>`,
        {
            ...optionsLayout,
            getShape: function () {
                const element = document.querySelector('.MapOnePoint__point');

                if (!element) {
                    return MyIconContentLayout.superclass.getShape.call(this);
                }
                const hHail = 9;
                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                    [
                        element.offsetLeft - element.offsetWidth,
                        element.offsetTop - element.offsetHeight,
                    ], [
                        element.offsetLeft,
                        element.offsetTop + hHail,
                    ],
                ]));
            },
        },
    );

    return {
        iconLayout: MyIconContentLayout,
        iconShape: {
            type: 'Rectangle',
            coordinates: [
                [-25, -25], [25, 25]
            ]
        },
        ...options,
    };
}
